export default "__VITE_ASSET__0e059a63__"